import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { RestEndpoints } from "../../../api/endpoints";
import { IPomReportingDraftModel } from "../../models/reportings/pom-reporting-draft.model";
import { PomQueryKeys } from "../../pom-query-keys";
import getInstance from "../../../utils/rest";

const getReportingDraft = async (
  contractNo: string,
  reportingNo: number,
): Promise<IPomReportingDraftModel | null> => {
  try {
    const result = await getInstance().get<IPomReportingDraftModel>(
      `${RestEndpoints.PomReportingDrafts}/${contractNo}/${reportingNo}`,
    );
    return result.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const useGetReportingDraftQuery = (
  contractNo: string | undefined,
  reportingNo: number | undefined,
) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetReportingDraft, contractNo, reportingNo],
    queryFn: () => getReportingDraft(contractNo as string, reportingNo as number),
    enabled: !!contractNo && reportingNo !== undefined,
  });
};
